import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule  } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';
//import { NgxEditorModule } from 'ngx-editor';


import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import {ChatUserListComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import {FriendComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import {ChatMsgComponent} from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import {NgxSimpleTextEditorModule} from 'ngx-simple-text-editor';
import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
import {ArchwizardModule} from 'angular-archwizard';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbAccordionModule, NgbButtonsModule, NgbCollapseModule, NgbDropdownModule, NgbPaginationModule, NgbTabsetModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './page/login/login.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ToastrModule } from 'ngx-toastr';
import {TextMaskModule} from 'angular2-text-mask';
import {NgNumberFormatterModule} from 'ng-number-formatter';

import { FullTextSearchPipe  } from './shared/filter.pipe';
import { SanitizeHtmlPipe  } from './shared/sanitize.pipe';
import { LoggedInGuard } from './page/security/loggedin.quard';
import { NgxSpinnerModule } from 'ngx-spinner';
import {ColorPickerModule} from 'ngx-color-picker';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './page/home/home.component';
import {TinymceModule} from 'angular2-tinymce';
import { SelectModule } from 'ng-select';
import {TagInputModule} from 'ngx-chips';
import {DragulaModule, DragulaService} from 'ng2-dragula';
import { SelectOptionService } from './theme/shared/components/select/select-option.service';
import { BarRatingModule } from 'ngx-bar-rating';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderByPipe } from './shared/orderBy.pipe';
import { HomeGestaoComponent } from './page/home-gestao/home-gestao.component';
import { HomeOperadoraComponent } from './page/home-operadora/home-operadora.component';
import { HomeEmpresaComponent } from './pages/Empresa/home-empresa/home-empresa.component';
import { CadastroPesquisadorComponent } from './pages/Empresa/cadastro-pesquisador/cadastro-pesquisador.component';
import { CadastroTradutorComponent } from './pages/Empresa/cadastro-tradutor/cadastro-tradutor.component';
import { CadastroAdvogadoComponent } from './pages/Empresa/cadastro-advogado/cadastro-advogado.component';
import { ChatComponent } from './pages/Empresa/chat/chat.component';
import { LandpageComponent } from './pages/site/landpage/landpage.component';
import { ColetaTradutorComponent } from './pages/site/coleta-tradutor/coleta-tradutor.component';
import { ColetaPesquisadorComponent } from './pages/site/coleta-pesquisador/coleta-pesquisador.component';
import { ColetaAdvogadoComponent } from './pages/site/coleta-advogado/coleta-advogado.component';
import { ColetaClienteComponent } from './pages/site/coleta-cliente/coleta-cliente.component';
import { CadastroClienteComponent } from './pages/Empresa/cadastro-cliente/cadastro-cliente.component';
import { CadastroResponsavelComponent } from './pages/Empresa/cadastro-responsavel/cadastro-responsavel.component';
import { EmConstrucaoComponent } from './pages/site/em-construcao/em-construcao.component';
import { PerfilClienteComponent } from './pages/Cliente/perfil-cliente/perfil-cliente.component';
import { DocumentosComponent } from './pages/Cliente/documentos/documentos.component';
import { ChatClienteComponent } from './pages/Cliente/chat-cliente/chat-cliente.component';
import { HomeClienteComponent } from './pages/Cliente/home-cliente/home-cliente.component';
import { CadastroCartorioComponent } from './pages/Empresa/cadastro-cartorio/cadastro-cartorio.component';
import { StatusClienteComponent } from './pages/Empresa/status-cliente/status-cliente.component';
import { ConsultarClienteComponent } from './pages/Empresa/consultar-cliente/consultar-cliente.component';
import { ModalCadastroClienteComponent } from './pages/Empresa/modal-cadastro-cliente/modal-cadastro-cliente.component';
import { ModalVisualizarClienteComponent } from './pages/Empresa/modal-visualizar-cliente/modal-visualizar-cliente.component';
import { ConsultarAtendimentosComponent } from './pages/Empresa/consultar-atendimentos/consultar-atendimentos.component';
import { CadastrarUsuariosComponent } from './pages/Empresa/cadastrar-usuarios/cadastrar-usuarios.component';
import { UsuariosAtivosComponent } from './pages/Empresa/usuarios-ativos/usuarios-ativos.component';
import { UsuariosInativosComponent } from './pages/Empresa/usuarios-inativos/usuarios-inativos.component';
import { CadastroTipoServicoComponent } from './pages/Empresa/cadastro-tipo-servico/cadastro-tipo-servico.component';
import { MensagemAutomaticaComponent } from './pages/Empresa/mensagem-automatica/mensagem-automatica.component';
import { CadastroAssessorComponent } from './pages/Empresa/cadastro-assessor/cadastro-assessor.component';
import { VisualizarAssessorComponent } from './pages/Empresa/visualizar-assessor/visualizar-assessor.component';
import { CadastroMicroservicosComponent } from './pages/Empresa/cadastro-microservicos/cadastro-microservicos.component';
import { ConsultarMicroservicosComponent } from './pages/Empresa/consultar-microservicos/consultar-microservicos.component';
import { DadosEmpresaComponent } from './pages/Empresa/dados-empresa/dados-empresa.component';
import { CadastroTabelaPrecoComponent } from './pages/Empresa/cadastro-tabela-preco/cadastro-tabela-preco.component';
import { VisualizarTabelaValoresComponent } from './pages/Empresa/visualizar-tabela-valores/visualizar-tabela-valores.component';
import { DisponibilizarHorariosComponent } from './pages/Empresa/disponibilizar-horarios/disponibilizar-horarios.component';
import { AgendarAtendimentoComponent } from './pages/Empresa/agendar-atendimento/agendar-atendimento.component';
import { MinhaAgendaComponent } from './pages/Empresa/minha-agenda/minha-agenda.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgendarHorariosComponent } from './pages/Empresa/agendar-horarios/agendar-horarios.component';
import { ContatoComponent } from './pages/Empresa/contato/contato.component';
import { ArvoreGenealogicaComponent } from './pages/Empresa/arvore-genealogica/arvore-genealogica.component';
import { DocumentosConsultaComponent } from './pages/Empresa/documentos-consulta/documentos-consulta.component';
import { UploadDocumentosConsultaComponent } from './pages/Empresa/upload-documentos-consulta/upload-documentos-consulta.component';
import { VisualizarFormularioComponent } from './pages/Empresa/visualizar-formulario/visualizar-formulario.component';
import { OrcamentosConsultaComponent } from './pages/Empresa/orcamentos-consulta/orcamentos-consulta.component';
import { NovoOrcamentoConsultaComponent } from './pages/Empresa/novo-orcamento-consulta/novo-orcamento-consulta.component';
import { FinNaturezaDocumentoComponent } from './pages/Empresa/fin-natureza-documento/fin-natureza-documento.component';
import { StatusFornecedorComponent } from './pages/Empresa/status-fornecedor/status-fornecedor.component';
import { TipoPagamentoComponent } from './pages/Empresa/tipo-pagamento/tipo-pagamento.component';
import { FinDocumentoComponent } from './pages/Empresa/fin-documento/fin-documento.component';
import { CadastrarFornecedorComponent } from './pages/Empresa/cadastrar-fornecedor/cadastrar-fornecedor.component';
import { ConsultarFornecedorComponent } from './pages/Empresa/consultar-fornecedor/consultar-fornecedor.component';
import { CadastrarTabelaPrecoFinComponent } from './pages/Empresa/cadastrar-tabela-preco-fin/cadastrar-tabela-preco-fin.component';
import { ConsultarTabelaPrecoFinComponent } from './pages/Empresa/consultar-tabela-preco-fin/consultar-tabela-preco-fin.component';
import { ContasPagarComponent } from './pages/Empresa/contas-pagar/contas-pagar.component';
import { ConsultarContasPagarComponent } from './pages/Empresa/consultar-contas-pagar/consultar-contas-pagar.component';
import { ContasReceberComponent } from './pages/Empresa/contas-receber/contas-receber.component';
import { SelectBuscaComponent } from './components/select-busca/select-busca.component';
import { ConsultarContasReceberComponent } from './pages/Empresa/consultar-contas-receber/consultar-contas-receber.component';
import { PlanoContasComponent } from './pages/Empresa/plano-contas/plano-contas.component';
import { CentroCustosComponent } from './pages/Empresa/centro-custos/centro-custos.component';
import { PlanoContasTreeComponent } from './pages/Empresa/plano-contas-tree/plano-contas-tree.component';
import { FluxoCaixaComponent } from './pages/Empresa/fluxo-caixa/fluxo-caixa.component';
import { AnaliseCentroCustosComponent } from './pages/Empresa/analise-centro-custos/analise-centro-custos.component';
import { FluxoCaixaDiarioProjetadoComponent } from './pages/Empresa/fluxo-caixa-diario-projetado/fluxo-caixa-diario-projetado.component';
import { FluxoCaixaDiarioRealizadoComponent } from './pages/Empresa/fluxo-caixa-diario-realizado/fluxo-caixa-diario-realizado.component';
import { BancoSantanderComponent } from './pages/Empresa/banco-santander/banco-santander.component';
import { GerarBoletoComponent } from './pages/Empresa/gerar-boleto/gerar-boleto.component';
import { GerarCnabComponent } from './pages/Empresa/gerar-cnab/gerar-cnab.component';
import { ConfiguracaoCnabSantanderComponent } from './pages/Empresa/configuracao-cnab-santander/configuracao-cnab-santander.component';
import { ConfiguracaoApiBanrisulComponent } from './pages/Empresa/configuracao-api-banrisul/configuracao-api-banrisul.component';
import { ImportarRetornoCnabComponent } from './pages/Empresa/importar-retorno-cnab/importar-retorno-cnab.component';
import { ImportarExtratoBancoComponent } from './pages/Empresa/importar-extrato-banco/importar-extrato-banco.component';
import { FiltrosDefinidosComponent } from './page/filtros-definidos/filtros-definidos.component';






//import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
//import {getDatabase, provideDatabase } from '@angular/fire/database';
//import { environment } from 'src/environments/environment';



//import { AdvRatingComponent } from './demo/ui-elements/ui-adv/adv-rating/adv-rating.component';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    FriendComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective,
    LoginComponent,
    HomeComponent,
    FullTextSearchPipe,
    SanitizeHtmlPipe,
    OrderByPipe,   
    HomeGestaoComponent,
    HomeOperadoraComponent,
    HomeEmpresaComponent,
    CadastroPesquisadorComponent,
    CadastroTradutorComponent,
    CadastroAdvogadoComponent,
    ChatComponent,
    LandpageComponent,
    ColetaTradutorComponent,
    ColetaPesquisadorComponent,
    ColetaAdvogadoComponent,
    ColetaClienteComponent,
    CadastroClienteComponent,
    CadastroResponsavelComponent,
    EmConstrucaoComponent,
    PerfilClienteComponent,
    DocumentosComponent,
    ChatClienteComponent,
    HomeClienteComponent,
    CadastroCartorioComponent,
    StatusClienteComponent,
    ConsultarClienteComponent,
    ModalCadastroClienteComponent,
    ModalVisualizarClienteComponent,
    ConsultarAtendimentosComponent,
    CadastrarUsuariosComponent,
    UsuariosAtivosComponent,
    UsuariosInativosComponent,
    CadastroTipoServicoComponent,
    MensagemAutomaticaComponent,
    CadastroAssessorComponent,
    VisualizarAssessorComponent,
    CadastroMicroservicosComponent,
    ConsultarMicroservicosComponent,
    DadosEmpresaComponent,
    CadastroTabelaPrecoComponent,
    VisualizarTabelaValoresComponent,
    DisponibilizarHorariosComponent,
    AgendarAtendimentoComponent,
    MinhaAgendaComponent,
    AgendarHorariosComponent,
    ContatoComponent,
    ArvoreGenealogicaComponent,
    DocumentosConsultaComponent,
    UploadDocumentosConsultaComponent,
    VisualizarFormularioComponent,
    OrcamentosConsultaComponent,
    NovoOrcamentoConsultaComponent,
    FinNaturezaDocumentoComponent,
    StatusFornecedorComponent,
    TipoPagamentoComponent,
    FinDocumentoComponent,
    CadastrarFornecedorComponent,
    ConsultarFornecedorComponent,
    CadastrarTabelaPrecoFinComponent,
    ConsultarTabelaPrecoFinComponent,
    ContasPagarComponent,
    ConsultarContasPagarComponent,
    ContasReceberComponent,
    ConsultarContasReceberComponent,
    PlanoContasComponent,
    CentroCustosComponent,
    PlanoContasTreeComponent,
    FluxoCaixaComponent,
    AnaliseCentroCustosComponent,
    FluxoCaixaDiarioProjetadoComponent,
    FluxoCaixaDiarioRealizadoComponent,
    BancoSantanderComponent,
    GerarBoletoComponent,
    GerarCnabComponent,
    ConfiguracaoCnabSantanderComponent,
    ConfiguracaoApiBanrisulComponent,
    ImportarRetornoCnabComponent,
    ImportarExtratoBancoComponent,
    FiltrosDefinidosComponent,
    SelectBuscaComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule ,
    SharedModule,
    NgbModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    NgbCollapseModule,
    NgbAccordionModule,
    NgbPaginationModule,
    FileUploadModule,
    NgxSpinnerModule,
    TextMaskModule,
    ColorPickerModule,
    HttpClientModule,
    TinymceModule,
    SelectModule,
    TagInputModule,
    DragulaModule,
    BarRatingModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    ArchwizardModule,
    NgxSimpleTextEditorModule,
    ToastrModule.forRoot(),
    FullCalendarModule
    //NgxEditorModule,
    //provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    //provideDatabase(() => getDatabase()),
    


  ],
  providers: [NavigationItem, LoggedInGuard, DragulaService, SelectOptionService],
  bootstrap: [AppComponent]
})
export class AppModule { }
